const COMMUNITY_GOALS = {
	menu: 'COMMUNITY_MENU_CLICK',
	question: 'COMMUNITY_QUESTION_CLICK',
} as const;

type CommunityClick = {
	location: string;
	item?: string;
};

type Metrica = {
	reachGoal: (goal: string, parameters: Record<string, unknown>) => void;
};

export function trackCommunityClick(
	metrica: Metrica,
	kind: keyof typeof COMMUNITY_GOALS,
	click: CommunityClick,
) {
	try {
		metrica.reachGoal(COMMUNITY_GOALS[kind], { community: click });
	} catch {
		// Analytics must not block navigation.
	}
}
